import { render, staticRenderFns } from "./OutputsCard.vue?vue&type=template&id=1ad3bebd&"
import script from "./OutputsCard.vue?vue&type=script&lang=ts&"
export * from "./OutputsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports